import React from 'react';

export type TableProps = React.TableHTMLAttributes<HTMLTableElement>;
export type TableSectionProps = React.HTMLAttributes<HTMLTableSectionElement>;
export type TableRowProps = React.HTMLAttributes<HTMLTableRowElement>;
export type TableCellProps = React.TdHTMLAttributes<HTMLTableCellElement> & {
  align?: 'left' | 'center' | 'right';
};
export type TableHeaderCellProps = React.ThHTMLAttributes<HTMLTableCellElement> & {
  align?: 'left' | 'center' | 'right';
};

export const Table: React.FC<TableProps> = ({ className = '', ...props }) => (
  <table className={className} {...props} />
);

export const THead: React.FC<TableSectionProps> = ({ className = '', ...props }) => (
  <thead className={className} {...props} />
);

export const TBody: React.FC<TableSectionProps> = ({ className = '', ...props }) => (
  <tbody className={className} {...props} />
);

export const TR: React.FC<TableRowProps> = ({ className = '', ...props }) => (
  <tr className={className} {...props} />
);

const alignClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};

export const TH: React.FC<TableHeaderCellProps> = ({
  align = 'left',
  className = '',
  ...props
}) => (
  <th className={`p-4 font-medium text-slate-600 ${alignClasses[align]} ${className}`} {...props} />
);

export const TD: React.FC<TableCellProps> = ({ align = 'left', className = '', ...props }) => (
  <td className={`p-4 ${alignClasses[align]} ${className}`} {...props} />
);

export type EmptyRowProps = {
  colSpan: number;
  className?: string;
  children?: React.ReactNode;
};

export const EmptyRow: React.FC<EmptyRowProps> = ({ colSpan, className = '', children }) => (
  <TR>
    <TD colSpan={colSpan} className={className}>
      {children}
    </TD>
  </TR>
);
